__turbopack_context__.v({
  "jobTeamSection": "_6NwZkG_jobTeamSection",
  "jobTeamSection__description": "_6NwZkG_jobTeamSection__description",
  "jobTeamSection__memberItem": "_6NwZkG_jobTeamSection__memberItem",
  "jobTeamSection__members": "_6NwZkG_jobTeamSection__members",
  "jobTeamSection__membersGrid": "_6NwZkG_jobTeamSection__membersGrid",
  "jobTeamSection__membersLabel": "_6NwZkG_jobTeamSection__membersLabel",
  "jobTeamSection__title": "_6NwZkG_jobTeamSection__title",
});
